const a = {
  "meta-navigation": "meta-navigation",
  "meta-navigation__items": "meta-navigation__items",
  "meta-navigation__item-icon": "meta-navigation__item-icon",
  "meta-navigation__item": "meta-navigation__item",
  "meta-navigation__item--icon": "meta-navigation__item--icon",
  "meta-navigation__item--active": "meta-navigation__item--active",
  "meta-navigation__item-link": "meta-navigation__item-link",
  "meta-navigation__separator": "meta-navigation__separator"
};
export {
  a as default
};
